import { resolve } from "path"
import api from "../api"
import { ocr } from "../apiVariables"
import { rejects } from "assert"

export const imageOcr = (body: any) => {
    return new Promise((resolve, reject) => {
        api({ ...ocr.imageAutoOcr, body }).then((res) => {
            resolve(res)
        }).catch((error) => {
            reject(error)
        })
    })
}

export const aadharMaskingApi = (body: any, extraParams: any) => {
    return new Promise((resolve, reject) => {
        api({ ...ocr.aadharMasking, body, extraParams }).then((res) => {
            resolve(res)
        }).catch((error) => {
            reject(error)
        })
    })
}

export const voterID = (body: any) => {
    return new Promise((resolve, reject) => {
        api({ ...ocr.voterId, body }).then((res) => {
            resolve(res)
        }).catch((error) => {
            reject(error)
        })
    })
}

export const genericOcr = (body: any) => {
    return new Promise((resolve, reject) => {
        api({ api: '/generic-ocr/upload', method: "post", baseurl: 'selfie', body }).then((res) => {
            resolve(res)
        }).catch((error) => {
            reject(error)
        })
    })
}

// Fetch OCR details for a previously uploaded document by its id.
// Polled by the page until the response status is success/failed.
export const getGenericOcrResult = (id: string) => {
    return new Promise((resolve, reject) => {
        api({ api: `/generic-ocr/response/${id}`, method: "get", baseurl: 'selfie' }).then((res) => {
            resolve(res)
        }).catch((error) => {
            reject(error)
        })
    })
}